import React from "react";
import { useTranslation } from "react-i18next";
import { Globe, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "./ui/dropdown-menu";
import { SUPPORTED_LANGS } from "../i18n";

export default function LanguageSwitcher({ compact = false }) {
  const { i18n, t } = useTranslation();
  const current = SUPPORTED_LANGS.find((l) => l.code === i18n.resolvedLanguage) || SUPPORTED_LANGS[0];

  const change = (code) => {
    i18n.changeLanguage(code);
    try { localStorage.setItem("anna11_lang", code); } catch {}
    // Update html lang attribute for a11y + SEO
    if (typeof document !== "undefined") {
      document.documentElement.lang = code;
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className={`inline-flex items-center gap-1.5 rounded-md text-sm font-medium border transition-colors ${
            compact
              ? "px-2 py-1.5 border-white/10 bg-white/5 text-slate-200 hover:text-[#FFB800] hover:bg-white/10"
              : "px-3 py-2 border-white/10 bg-white/5 text-slate-200 hover:text-[#FFB800] hover:bg-white/10"
          }`}
          aria-label={t("language.label", "Language")}
        >
          <Globe className="w-4 h-4" />
          <span className="hidden sm:inline">{current.native}</span>
          <span className="sm:hidden text-[11px] uppercase">{current.code}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-[#0e1730] border border-white/10 text-slate-100 min-w-[180px]">
        <DropdownMenuLabel className="text-xs text-slate-400 uppercase tracking-wider">{t("language.label", "Language")}</DropdownMenuLabel>
        <DropdownMenuSeparator className="bg-white/10" />
        {SUPPORTED_LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => change(l.code)}
            className={`cursor-pointer focus:bg-amber-500/15 focus:text-amber-300 ${
              l.code === current.code ? "text-amber-300" : ""
            }`}
          >
            <span className="flex-1">{l.native}</span>
            {l.code === current.code && <Check className="w-3.5 h-3.5" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
